import { timedCalls } from "./utils/misc";
import { onHeaderLargeScreen } from "./breakpoint-detect";

declare const jQuery: any;
const $ = jQuery;

const isOpenClass = "open";
const submenuSelector = ".sub-menu";
const openEvent = "open";
const $window = $(window);

type MouseMode = "touchstart"|"hover";

const onTouch: boolean = ("ontouchstart" in window);
const mouseMode: MouseMode = onTouch ? "touchstart" : "hover";

export function initMainHeaderNav(): void
{
	$('.main-header-menu').each(function eachHeader() {
		initNav(this);
	});
}

export function initNav($nav): void
{
	$nav = $($nav);
	$nav.find("ul.menu").on(openEvent, function (e) {
		e.stopPropagation(); // to distinguish $nav's own open event from submenu open event
	});
	const $allSubmenus = $nav.find(submenuSelector);
	if ($allSubmenus.length === 0)
	{
		return;
	}
	closeAllSubmenusOnNavMouseLeave($allSubmenus, $nav);
	initAllSubmenus($allSubmenus, $nav);
}

function closeAllSubmenusOnNavMouseLeave($allSubmenus, $nav): void
{
	if (onTouch)
	{
		return;
	}
	const closeAll = () => {
		closeSubmenus($allSubmenus);
	};
	$nav.on("mouseleave", closeAll);
	$nav.find("ul.menu > li:not(.menu-item-has-children) > a").on("mouseenter", closeAll);
}

function setUpLinkInteraction($allSubmenus, $submenu, $link): void
{
	if (mouseMode === "hover")
	{
		$link.on("mouseenter", e => {
			e.stopPropagation();
			if (!submenuIsOpen($submenu))
			{
				openSubmenu($allSubmenus, $submenu);
			}
		});
	}

	$link.on("click", e => {
		e.stopPropagation();

		if (!submenuIsOpen($submenu))
		{
			// open submenu
			e.preventDefault();
			openSubmenu($allSubmenus, $submenu);
			return false;
		}

		// submenu is already open

		if (linkIsEmpty($link))
		{
			// close submenu
			closeSubmenus($submenu);
			return false;
		}

		// follow link
	});

	$submenu.on("force-open", function () {
		openSubmenu($allSubmenus, $submenu);
	});
}

function closeOnMouseLeave($submenu, $nav)
{
	$submenu.on("mouseleave", e => {
		if (mouseMode === "touchstart")
		{
			return;
		}
		closeSubmenus(getChildSubmenus($submenu));
	});
}

function submenuIsOpen($submenu)
{
	return $submenu.hasClass(isOpenClass);
}

function getParentSubmenus($e)
{
	const $parents = $e.parents(submenuSelector);

	if ($e.is(submenuSelector))
	{
		$parents.add($e);
	}

	return $parents;
}

function getChildSubmenus($e)
{
	return $e.parent().find(submenuSelector);
}

function getSubmenuLineage($e)
{
	return getParentSubmenus($e).add(getChildSubmenus($e));
}

function closeSubmenus($submenus)
{
	$submenus.removeClass(isOpenClass).removeClass("overspill-correct").parent().removeClass("submenu-is-open");
}

function closeOtherSubmenus($allSubmenus, $theseSubmenus)
{
	const $otherSubmenus = $allSubmenus.not($theseSubmenus);
	closeSubmenus($otherSubmenus);
}

function fixSubmenuLayout($submenu)
{
	timedCalls(() => fixHorizOverspill($submenu), 2, 120);
}

function openSubmenu($allSubmenus, $submenu)
{
	closeOtherSubmenus($allSubmenus, getSubmenuLineage($submenu));
	$submenu.addClass(isOpenClass).parent().addClass("submenu-is-open");
	$submenu.trigger(openEvent);
	fixSubmenuLayout($submenu);
}

function getSubmenuTopLink($menu)
{
	return $menu.parent("li").children("a");
}

function linkIsEmpty($link)
{
	const href = $link.attr("href");
	return !href || (href === "#");
}

function initSubmenu($submenu, $allSubmenus, $nav)
{
	const $link = getSubmenuTopLink($submenu);
	setUpLinkInteraction($allSubmenus, $submenu, $link);
	closeOnMouseLeave($submenu, $nav);
	fixSubmenuLayout($submenu); // for IE
}

function initAllSubmenus($allSubmenus, $nav)
{
	$allSubmenus.each(index => {
		const $submenu = $allSubmenus.eq(index);
		initSubmenu($submenu, $allSubmenus, $nav);
	});
}

function fixHorizOverspill($submenu): void
{
	$submenu.css("left", "");

	if (!onHeaderLargeScreen() || $submenu.hasClass("no-layout-fix"))
	{
		return;
	}

	const $container = $submenu.closest("li");
	const $containerParent = $container.parent();
	const isNested = $containerParent.is(".sub-menu");
	
	if (isNested)
	{
		const containerHasOverspillCorrection: boolean = $containerParent.hasClass("overspill-correct");
		if (containerHasOverspillCorrection)
		{
			$submenu.css("left", `-${$submenu.outerWidth()}px`).addClass("overspill-correct");
			return;
		}
	}
	
	const rightOverspill = getRightOverspill($submenu);
	if (rightOverspill > 0)
	{
		if (isNested)
		{
			$submenu.css("left", `-${$submenu.outerWidth()}px`).addClass("overspill-correct");
		}
		else
		{
			$submenu.css("left", `-=${rightOverspill}`).addClass("overspill-correct");
		}
	}
}

function getRightOverspill($e)
{
	const width = $e.outerWidth();
	const left = $e.offset().left;
	const right = width + left;
	return right - $window.outerWidth();
}

// Export to global for use in child theme
if (!window["iw"])
{
	window["iw"] = {};
}
if (!window["iw"].nav)
{
	window["iw"].nav = {};
}
window["iw"].nav.initNav = initNav;
window["iw"].nav.setMouseMode = () => {
	// @deprecated Nov 2020
	console.warn("setMouseMode is deprecated, remove all references!");
};
